import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { observer, inject } from "mobx-react";

import PdpShare from "../PdpShare";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import { setWishlist } from "../../ProductList/ProductUtil";
import { Utils } from "arv-reactcomponents";

@inject("LoginStore")
@observer
class PdpIcons extends Component {
  constructor() {
    super();
    this.onClickfitGuideModal = this.onClickfitGuideModal.bind(this);
    this.onShortListClick = this.onShortListClick.bind(this);
  }
  onShortListClick() {
    const { isUserLoggedIn } = this.props.LoginStore;
    const { styleId } = this.props;
    const isWishListed = this.props.wishListData.find(
      product => product.styleId === styleId,
    );
    if (isUserLoggedIn) {
      this.props.setWishList(styleId, isWishListed);
    } else {
      setWishlist(styleId);
      this.props.LoginStore.setloginModal(true);
      Analytics.trackEvent({
        action: Event.action.SHORTLIST_PRE_LOGIN,
        label: styleId,
        category: Event.category.PRODUCT_DESCRIPTION_PAGE,
      });
    }
  }
  onClickfitGuideModal() {
    this.props.fitGuideModal();
    Analytics.trackEvent({
      action: Event.action.FIT_GUIDE_CLICK,
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
    });
  }
  get isLoader() {
    return this.props.ProductLoader ? "nwc-hide" : "";
  }
  get wishlisted() {
    const { styleId } = this.props;
    const { isUserLoggedIn } = this.props.LoginStore;
    const isWishListed = this.props.wishListData.find(
      product => product.styleId === styleId,
    );
    return isUserLoggedIn && isWishListed ? "active" : "";
  }
  render() {
    const { sizeChartId, name, brandName, images, inStock } = this.props;
    return (
      <div className={`nw-pdp-iconlist ${this.isLoader}`}>
        <div
          className={`nw-pdpdetails-iconswrapper ${
            sizeChartId ? "" : "nwc-hide"
          }`}
        >
          <div
            role="button"
            className="nwc-btn nw-pdpdetails-fitguide nw-pdpdetails-icons"
            onClick={this.onClickfitGuideModal}
            onKeyDown={Utils.noop}
            tabIndex={0}
          >
            <i className="icomoon-ruler-black nw-pdpicons-icon nw-pdp-rulericon" />
          </div>
          <span className="nw-pdpdetails-iconstext">Fit Guide</span>
        </div>
        <div className="nw-pdpdetails-iconswrapper">
          <div
            role="button"
            className={`nwc-btn nw-pdpdetails-icons nw-pdp-favourite ${
              this.wishlisted
            }`}
            onClick={this.onShortListClick}
            onKeyDown={Utils.noop}
            tabIndex={0}
          >
            <i
              className={`nw-pdp-hearticon nw-pdpicons-icon icomoon-heart${
                this.wishlisted ? "" : "-o"
              }`}
            />
          </div>
          <span className="nw-pdpdetails-iconstext">{` ${
            this.wishlisted ? "Favorited" : "Favorite"
          }`}</span>
        </div>
        <div className="nw-pdpdetails-iconswrapper">
          <PdpShare
            brandName={brandName}
            name={name}
            images={images}
            inStock={inStock}
          />
          <span className="nw-pdpdetails-iconstext">Share</span>
        </div>
      </div>
    );
  }
}

PdpIcons.wrappedComponent.defaultProps = {
  ProductLoader: false,
  sizeChartId: "",
  brandName: "",
  name: "",
  images: [],
  styleId: "",
  inStock: true,
};
PdpIcons.wrappedComponent.propTypes = {
  LoginStore: PropTypes.shape({
    setloginModal: PropTypes.func.isRequired,
    isUserLoggedIn: PropTypes.bool.isRequired,
  }).isRequired,
  ProductLoader: PropTypes.bool,
  sizeChartId: PropTypes.string,
  styleId: PropTypes.string,
  brandName: PropTypes.string,
  name: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      medium: "",
    }),
  ),
  inStock: PropTypes.bool,
  setWishList: PropTypes.func.isRequired,
  wishListData: PropTypes.object, // eslint-disable-line
  fitGuideModal: PropTypes.func.isRequired,
};

export default PdpIcons;



// WEBPACK FOOTER //
// ./src/component/PdpComponents/PdpIcons/index.js